import { createReportRenderer } from '@varos/research-renderer-report';
export function createReportContentRepository(config) {
    const { repository, client } = config;
    const renderer = createReportRenderer();
    function toReportContent(content, blocks) {
        const rendered = renderer.render({
            content: {
                ordinal: content.ordinal,
                visibility: content.visibility,
            },
            blocks: blocks,
        });
        if (rendered.issues.length > 0) {
            console.error('rendered.issues', rendered.issues);
        }
        return {
            number: rendered.output.number,
            title: rendered.output.title,
            subtitle: rendered.output.subtitle,
            summary: rendered.output.summary,
            sections: rendered.output.sections,
        };
    }
    return {
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'content', 'lookup', props.id],
                async queryFn() {
                    const [responseContent, responseBlock] = await Promise.all([
                        client.user.default.contentRetrieve({
                            contentId: props.id,
                        }, {
                            headers: {
                                'x-workspace-id': 'test',
                            },
                        }),
                        client.user.default.blockList({
                            content: props.id,
                        }, {
                            headers: {
                                'x-workspace-id': 'test',
                            },
                        }),
                    ]);
                    return toReportContent(responseContent.data, responseBlock.data.data);
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportContentRepository.js.map